export class ConectionStatusDto {

    credencialUsuario: number;
	
	fechaSuceso: Date;
	
	estado: ConectionEnum;
}

export enum ConectionEnum {
    CONECTADO = 'SI',
    DESCONECTADO = 'NO'
}